// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-drawer-link {
  margin: auto;
  margin-bottom: 32px;
  width: -moz-fit-content;
  width: fit-content;
  block-size: -moz-fit-content;
  block-size: fit-content;
}

.lr-question-bottom {
  margin-bottom: 15px;
  text-align: center;
}

.lr-drawer-body-desc {
  padding-bottom: 24px;
}

.lr-drawer {
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 0px;
}

.question-title {
  width: 540px;
}

.lr-drawer-title {
  font-size: 39px;
  font-style: normal;
  font-weight: 600;
  line-height: 39px;
  font-family: "Mecherle Sans";
  padding-top: 25px;
  padding-bottom: 24px;
}

.subtext-title {
  font-family: "Mecherle Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.subtext-text {
  font-family: "Mecherle Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/incident-details/purpose-of-trip-work-related/purpose-of-trip-work-related.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,4BAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".lr-drawer-link {\n  margin: auto;\n  margin-bottom: 32px;\n  width: fit-content;\n  block-size: fit-content;\n}\n\n.lr-question-bottom {\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.lr-drawer-body-desc {\n  padding-bottom: 24px;\n}\n\n.lr-drawer {\n  padding-left: 32px;\n  padding-right: 32px;\n  padding-top: 0px;\n}\n\n.question-title {\n  width: 540px;\n}\n\n.lr-drawer-title {\n  font-size: 39px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 39px;\n  font-family: \"Mecherle Sans\";\n  padding-top: 25px;\n  padding-bottom: 24px;\n}\n\n.subtext-title {\n  font-family: \"Mecherle Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.subtext-text {\n  font-family: \"Mecherle Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 21px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
